export const accountMenu = {
  roles: {
    collaborator: "Mitarbeiter",
    hostMode: "Gastgeber-Modus",
  },
  header: {
    collaboratorAccess: "Mitarbeiterzugang",
  },
  panel: {
    label: "Panelansicht",
    apartment: "Wohnung",
    hotel: "Hotel",
  },
  groups: {
    navigate: "Navigation",
    manage: "Verwalten",
  },
  items: {
    home: "Start",
    bookings: "Buchungen",
    myAccount: "Mein Konto",
    myAccommodations: "Meine Unterkünfte",
    aiReception: "KI-Rezeption",
    aiReceptionist: "KI-Rezeptionist",
    directBookings: "Direktbuchungen",
    website: "Website",
    logout: "Abmelden",
  },
  badges: {
    ai: "KI",
    new: "NEU",
  },
  actions: {
    close: "Schließen",
  },
};
